module.exports = __webpack_public_path__ + "img/music.eeeb39ff.png";